export const ACH_DEPOSIT_SUCCESS_SURVEY = 'ach_deposit_success_survey';
export const INSTANT_DEPOSIT_SUCCESS_SURVEY = 'instant_deposit_success_survey';
export const BANKING_APPLICATION_SUCCESS_SURVEY = 'banking_application_success_survey';
